import { CollapseComponent } from "@opten/collapse";
import { factory } from "@opten/compiler/factory";
import { DateRangeComponent } from "./components/sge/daterange";
import { NavbarComponent } from "./components/radix/navbar";
import { AlertComponent } from "./components/shared/alert";
import { DatepickerComponent } from "./components/shared/datepicker";
import { FilterComponent } from "./components/shared/filter";
import { FormCheckboxesComponent } from "./components/shared/form-checkboxes";
import { FormSelectUpdateComponent } from "./components/shared/form-select-updater";
import { FormTemplatesComponent } from "./components/shared/form-templates";
import { FormTotalComponent } from "./components/shared/form-total";
import { GlobalVarsComponent } from "./components/shared/globalvars";
import { GridComponent } from "./components/shared/grid";
import { HeadlineSliderComponent } from "./components/shared/headline-slider";
import { InputComponent } from "./components/shared/input";
import { MediaSliderComponent } from "./components/shared/media-slider";
import { ModalComponent } from "./components/shared/modal";
import { PageTopComponent } from "./components/shared/page-top";
import { PageTransitionComponent } from "./components/shared/page-transition";
import { PasswordRevealComponent } from "./components/shared/password-reveal";
import { ReCaptchaComponent } from "./components/shared/recaptcha";
import { ScrollToComponent } from "./components/shared/scroll-to";
import { StickyComponent } from "./components/shared/sticky";
import { TabDropComponent } from "./components/shared/tabdrop";
import { TextSliderComponent } from "./components/shared/text-slider";
import { PaginationComponent } from "./components/sge/pagination";
import { MultilanguageDownloadComponent } from "./components/sge/multilanguage-download";
import { DownloadTracker } from "./components/sge/download-tracker";
import './components/shared/image';
import { FormComponent } from "./components/shared/form";
import { FlipbookComponent } from "./components/shared/flipbook";

const initialize = factory([
	PageTransitionComponent,
	TabDropComponent,
	NavbarComponent,
	HeadlineSliderComponent,
	MediaSliderComponent,
	TextSliderComponent,
	ModalComponent,
	FilterComponent,
	InputComponent,
	FormComponent,
	FormTotalComponent,
	FormTemplatesComponent,
	FormCheckboxesComponent,
	FormSelectUpdateComponent,
	PasswordRevealComponent,
	DatepickerComponent,
	CollapseComponent,
	ScrollToComponent,
	GridComponent,
	StickyComponent,
	ReCaptchaComponent,
	PageTopComponent,
	DateRangeComponent,
	AlertComponent,
	PaginationComponent,
	MultilanguageDownloadComponent,
	DownloadTracker,
	FlipbookComponent,
]);

initialize(document.body);

PageTransitionComponent.onPageChange.subscribe((container) => {
	initialize(container);
});

const vars = new GlobalVarsComponent();

// TODO: Please adjust, only been copied from lsusw.ts
